<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <Modal
    :title="modalTitle"
    :closable="false"
    :mask-closable="false"
    @on-visible-change="onVisibleChange"
    v-model="modalShowHide"
    class="modal-setting"
    :width="820"
    footer-hide
    class-name="vertical-center-modal"
  >
    <div style="background-color: white">
      <div class="w-full">
        <div class="m-auto bg-white" style="width: 820px;">
          <div class="p-h-20 p-t-10">
            <Row :gutter="16">
              <Col span="12">
                <div style="">
                  <div class="flex-column a-center j-center"
                       style="height: 255px;background-color: #F6F9FF;cursor: pointer;padding-bottom: 5px"
                       v-if="false">
                    <img alt="" src="../../../../assets/common/ic_upload_video@2x.png"
                         style="width: 64px;height: 64px">
                    <span class="m-t-5  color-66">上传视频</span>
                  </div>

                  <div class="o-hidden w-full"
                       style="height: 255px;position: relative;top: 0;left: 0;">
                    <video-upload-s :canclick="canclick" :funcallback="onVideoUpload"
                                    @uploadSuccess="uploadFileSuccess"
                                    @uploadstart="onItemVideoUploadStart"
                                    videoInfix="common/desc/">
                      <template slot="tip">
                        <div class="flex-column a-center j-center w-full"
                             style="height: 255px;background-color: #F6F9FF;"
                             v-if="!mp4Url">
                          <img alt="" src="../../../../assets/common/ic_upload_video@2x.png"
                               style="width: 64px;height: 64px"
                               v-if="progress === 0">
                          <div class="m-t-5  color-66" v-if="progress === 0">上传视频</div>

                          <Progress :percent="progress" class="p-h-10" v-if="progress>0"/>
                        </div>

                        <div class="flex a-center j-center w-full" style="height: 255px;"
                             v-if="mp4Url">
                          <video :src="mp4Url" class="w-full h-full" id="video-sid" ref="video"
                                 style="object-fit: fill"></video>
                          <img alt="" class="absolute right-150 top-68 w-50 h-50"
                               src="../../../../assets/common/ic_player(2).png"
                               style="z-index: 20;">
                        </div>
                      </template>
                    </video-upload-s>
                    <div @click="onVideoDelClick"
                         style="z-index: 10;position: absolute;right: 0;top: 0"
                         v-if="mp4Url">
                      <img alt="" src="../../../../assets/common/ic_delete_circle_red.png">
                    </div>
<!--                    <div class="absolute left-0 top-0 w-full" style="height: 204px;"-->
<!--                         v-if="mp4Url">-->
<!--                      <img :src="imgUrl" alt="" class="w-full"-->
<!--                           style="height: 255px;object-fit: cover">-->
<!--                    </div>-->

                    <div class="absolute left-0 top-0 w-full" style="height: 204px;" v-if="mp4Url && imgUrl">
                      <img :src="imgUrl" alt="" class="w-full" style="height: 255px;background-color: rgb(246, 249, 255)">
                    </div>
                  </div>

                </div>

                <div class="color-66 fs-12 p-t-10" style="">
                  视频格式为mp4,视频大小不超过200Mb
                </div>
              </Col>
              <Col span="12">
                <div>
                  <div @click="onPicChoose" style="position: relative;left: 0;top: 0">
                    <div class="flex-column a-center j-center w-full"
                         style="height: 255px;background-color: #F6F9FF;cursor: pointer">
                      <img alt="" src="../../../../assets/common/ic_upload_picture@2x.png"
                           style="width: 64px;height: 64px">
                      <span class="m-t-5  color-66">上传视频封面</span>
                    </div>
                    <div class="o-hidden"
                         style="position: absolute;height: 255px;left: 0;top: 0;right:0;background-color: #F6F9FF;"
                         v-if="imgUrl">
                      <img :src="imgUrl" class="w-full" style="height: 255px;object-fit: cover"/>
                    </div>
                  </div>
                </div>
                <div class="color-66 fs-12 p-t-10" style="">
                  图片格式为jpg或png,图片比例为4:3,图片大小不超过5Mb
                </div>
              </Col>
            </Row>

          </div>

          <div class="m-t-10 p-h-20">
            <Row :gutter="15">
              <Col span="12">
                <class-vertical-choose-widget :objData="objData" :srcType="10"
                                              direction="horizontal"
                                              leftLabelText="视频分类"
                                              rightLabelText="视频分组">

                </class-vertical-choose-widget>
              </Col>
              <Col span="12">
                <div class="w-full" style="height: 80px;">
                  <span class="bold fs-14 color-33">视频标题:</span>
                  <Input class="m-t-10 w-full" maxlength="60" placeholder="视频标题" type="text"
                         v-model="VideoTitle"/>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <div class="w-full flex j-center p-b-10">
        <Button @click="onCancelClick" style="width: 100px">取消</Button>
        <Button @click="onVideoSaveClick" style="margin-left: 50px;width: 100px" type="primary">确定
        </Button>
      </div>

    </div>

    <pic-choice-widget
      :on-ok="picChoiceOk"
      ref="picChoiceWidget"
    />

  </Modal>
</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import UpLoadImage from '@/components/common/UpLoadImage'
import draggable from 'vuedraggable'
import UpLoadVideo from '@/components/common/UpLoadVideo'
import VideoEditTest from '@/components/common/VideoEditTest'
import ClassVerticalChooseWidget from '../../../../components/common/ClassVerticalChooseWidget'
import PicChoiceWidget from '../../../../components/common/chiose/PicChoiceWidget'
import VideoUploadS from '../../../../components/common/VideoUpload'
import {mapActions, mapMutations} from 'vuex'

export default {
  name: 'UploadEditVideoWidget',
  components: {
    PicChoiceWidget,
    ClassVerticalChooseWidget,
    VideoEditTest,
    BasePageComponent,
    UpLoadImage,
    draggable,
    UpLoadVideo,
    VideoUploadS
  },
  props:{
    onOk:Function,
    onCancel:Function,
  },
  data () {
    return {
      videoId: 0,              //视频id,获取详情

      //显示隐藏
      modalShowHide: false,
      modalTitle: '上传图片',
      modalType: 'upload',     //upload  edit

      objData: {
        classId: 0,
        groupId: 0,
        init: false
      },
      videoUrl: '',
      mp4Url: '',
      imgUrl: '',
      progress: 0,
      VideoTitle: '',
      canclick: true,

      // title: '',
      // isDragging: false,
      // imageList: [],            // 图片列表

      process: '',  //上传进度条

      dCGInfo: {
        classId: 0,
        groupId: 0
      },
    }
  },
  computed: {
    dragOptions1 () {    //拖动参数
      return {
        animation: 0,
        group: {
          name: 'description',
          // pull: 'clone',
          // put: false
        },
        scroll: true,
        ghostClass: 'ghost',
        scrollSensitivity: 30,
        forceFallback: false,
        disabled: false
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getDefaultCGInfo()
    },
    // onMove ({relatedContext, draggedContext}) {
    //   const relatedElement = relatedContext.element
    //   const draggedElement = draggedContext.element
    //   return (
    //     (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    //   )
    // },
    /**
     * 图片删除处理
     * @param arrayList
     * @param index
     */
    // onItemDel (arrayList, index) {
    //   arrayList.splice(index, 1)
    // },

    /**
     *上传图片
     * @param data
     */
    // uploadDescImageSuccess (data) {
    //   if (data && data.length) {
    //     let list = data.map(res => {
    //       return {
    //         url: res.url
    //       }
    //     })
    //     this.imageList = this.imageList.concat(list)
    //   }
    // },
    onItemVideoUploadStart () {
      this.canclick = false
      this.videoUrl = ''
      this.progress = 0
    },
    onVideoUpload (data) {
      this.progress = Number.parseInt(data * 100)
    },
    uploadFileSuccess (data) {
      if (data && data.length) {
        this.videoUrl = data[0].videoUrl
        this.mp4Url = data[0].videoUrl
        this.VideoTitle = data[0].localfile.name
      }
      this.progress = 0
      this.canclick = true

    },
    onPicChoose () {
      this.$refs.picChoiceWidget.show()
    },
    picChoiceOk (data) {
      if (data && data.length) {
        this.imgUrl = data[0].url
      }
    },
    onCancelClick () {
      this.hide()
    },
    onVideoSaveClick () {
      if (!this.videoUrl) {
        return this.$Message.warning('请先上传视频')
      }
      if (!this.VideoTitle) {
        return this.$Message.warning('请输入视频名称')
      }

      let width = 0
      let height = 0
      if (this.mp4Url) {
        let video = document.getElementById('video-sid')
        width = video.videoWidth
        height = video.videoHeight
      }

      let params = {
        groupId: this.objData.groupId,
        categoryId: this.objData.classId,
        coverImgUrl: this.imgUrl,
        length: this.$refs.video.duration,
        url: this.videoUrl,
        title: this.VideoTitle,
        desc: '',
        jumpLink: '',
        width: width || 0,
        height: height || 0,
      }

      if (this.modalType === 'upload') {
        this.addVideo(params).then(res => {
          if (res.code === 0) {
            this.hide()
            if (this.onOk){
              this.onOk()
            }
          }
          if (res.msg) {
            this.$Message.info(res.msg)
          }
        })
      } else {
        let id = this.videoId
        this.editVideo({
            id,
            params
          }
        ).then(res => {
          if (res.code === 0) {
            this.hide()
            if (this.onOk){
              this.onOk()
            }
          }
          if (res.msg) {
            this.$Message.info(res.msg)
          }
        })
      }
    },

    onVideoDelClick () {
      this.videoUrl = ''
      this.mp4Url = ''
    },

    async getDefaultCGInfo () {
      let params = {
        type: 10
      }
      let result = await this.getCategoryLists(params)
      if (result.code === 0) {
        let item = result.data.find(e => {
          return e.isDefault === 1
        })
        if (item && item.id) {
          this.dCGInfo.classId = item.id
          let p = {
            categoryId: item.id,
            type: 10
          }
          let res = await this.getGroupLists(p)
          if (res.code === 0) {
            let itemInfo = res.data.find(e => {
              return e.isDefault === 1
            })
            if (itemInfo && itemInfo.id) {
              this.dCGInfo.groupId = itemInfo.id
              this.objData = {
                classId: this.dCGInfo.classId,
                groupId: this.dCGInfo.groupId,
                init: true
              }
            }
          }
        }
      }
    },

    onVisibleChange (status) {
      if (status) {
        if (this.modalType=== 'upload')
          this.getDefaultCGInfo()
      } else {
        this.videoId = 0
        //显示隐藏
        this.modalShowHide = false
        this.modalTitle = '上传图片'
        this.modalType = 'upload'
        this.objData = {
          classId: 0,
          groupId: 0,
          init: false
        }
        this.videoUrl = ''
        this.mp4Url = ''
        this.imgUrl = ''
        this.progress = 0
        this.VideoTitle = ''
        this.canclick = true
        this.process = ''
        this.dCGInfo = {
          classId: 0,
          groupId: 0
        }
      }
    },

    getVideoDetails () {
      let id = this.videoId
      let params = {}
      this.getVideoDetail({
        id,
        params
      }).then(res => {
        if (res.code === 0) {
          this.imgUrl = res.data.coverImgUrl
          this.videoUrl = res.data.url
          this.mp4Url = res.data.sourceUrl
          this.VideoTitle = res.data.title
          this.objData = {
            classId: res.data.categoryId,
            groupId: res.data.groupId,
            init: true
          }
        }
      })
    },

    showUpload () {
      this.modalTitle = '上传视频'
      this.modalType = 'upload'
      this.modalShowHide = true
    },
    showEdit (videoId) {
      this.modalTitle = '编辑视频'
      this.modalType = 'edit'
      this.videoId = videoId
      if (this.videoId) {
        this.getVideoDetails()
      }
      this.modalShowHide = true
    },

    hide () {
      this.modalShowHide = false
    },

    ...mapMutations([
      'closeTag'
    ]),
    ...mapActions([
      'addVideo',
      'getCategoryLists',
      'getGroupLists',
      'getVideoDetail',
      'editVideo'
    ])
  },

}
</script>

<style lang="scss" scoped>
.hoverstyle {
  &:hover {
    .showdel {
      display: block;
    }
  }

  .showdel {
    display: none;
  }
}


.modal-setting ::v-deep {

  .ivu-modal-header-inner {
    display: flex;
    justify-content: center;
    font-weight: bold;
  }

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
    background-color: #D1D2D3;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}
</style>
